import { TableName } from "src/lib/dexie-db/constants";
import { RemoteCollectionName } from "src/lib/sync-box/constants";
import SyncBoxFactory from "src/lib/sync-box/SyncBoxFactory";
import { getCurrentUserID } from "src/modules/authentication/storage/user/utils";
import { NODE_USER_SYNC_INTERVAL } from "./constants";
export const getNodeUserSyncBox = () => {
    return SyncBoxFactory.getInstance({
        collectionName: TableName.QNA_NODE_USER,
        remoteCollectionName: RemoteCollectionName.QNA_NODE_USER,
        pushConfig: {
            enabled: true,
        },
        pullConfig: {
            // Pull all user data for the current user
            filters: {
                userID: getCurrentUserID(),
            },
        },
        syncInterval: NODE_USER_SYNC_INTERVAL,
        staleThresholdDays: -1,
    });
};
